import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HelperService } from '@pwaPortal/core/services/helper/helper.service';
import { AsyncStorage } from '@sharedLib/services/storage/async-storage.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { PushNotifications } from '../../models/PushNotifications';

// function s4() {
//   return Math.floor((1 + Math.random()) * 0x10000)
//     .toString(16)
//     .substring(1);
// }

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private _ready$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public searchParams!: URLSearchParams;
  public pathParams!: URLSearchParams;

  get urlParams(): URLSearchParams {
    return this.pathParams.get('sub_id_1') ? this.pathParams : this.searchParams;
  }

  get appReady(): Observable<boolean> {
    return this._ready$.asObservable();
  }

  constructor(
    private storage: AsyncStorage,
    private pushNotifications: PushNotifications,
    private helperService: HelperService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.storage.ready().then(async () => {
      await this.init();
      this._ready$.next(true);
    });
  }

  private async init() {
    await this.helperService.initConfig(); // this must be triggered first to ensure config consistency
    await this.helperService.saveParams(); // if it's landing page - saving params for later use
    // await this.setDefaultLang(); // setting language for PWA
    this.pushNotifications.init(); // init push notifications
  }

  // private async setDefaultLang() {
  //   const config = await this.helperService.getPwaConfig();
  //   const languages = config.content.map((el) => el.languageCode as string);
  //   const defaultLanguage = (config.content.filter((el) => el.isDefault)[0].languageCode || languages[0]) as string;
  //   let browserLang = defaultLanguage;
  //   // If browser, select locale from browser
  //   if (isPlatformBrowser(this.platformId)) {
  //     const lang = window.navigator.language.split('-').shift();
  //     if (lang && languages.includes(lang)) browserLang = lang;
  //   }
  // }
}
